export default __webpack_public_path__ + "static/media/Dr.Shakira_Choonara.f2c6aea1.png";